var React = require('react');

function ArrowSimpleRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5 0.75L16.22 11.47C16.3607 11.6105 16.4398 11.8012 16.4398 12C16.4398 12.1988 16.3607 12.3895 16.22 12.53L5.5 23.25","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowSimpleRightInline.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowSimpleRightInline;

ArrowSimpleRightInline.default = ArrowSimpleRightInline;
